// src/pages/extensions/index.jsx
import React, { useState } from 'react';
import './style.scss';
import interfaceExtensions from './interfaceExtensions.json'; // Import the JSON data

const Extensions = () => {
  const [activeTab, setActiveTab] = useState('extensions');
  const [userExtensions, setUserExtensions] = useState([]);
  const [filters, setFilters] = useState({
    'send-message': false,
    'like-message': false,
    'dislike-message': false,
    'favorable-reply-message': false,
    'unfavorable-reply-message': false,
    'gift-message': false,
  });

  // Function to add an extension to userExtensions
  const addExtension = (extension) => {
    if (!userExtensions.some((ext) => ext.name === extension.name)) {
      setUserExtensions([...userExtensions, extension]);
    }
  };

  // Function to remove an extension from userExtensions
  const removeExtension = (extension) => {
    setUserExtensions(userExtensions.filter((ext) => ext.name !== extension.name));
  };

  // Function to handle filter changes
  const handleFilterChange = (op) => {
    setFilters({ ...filters, [op]: !filters[op] });
  };

  // Function to filter extensions based on active filters
  const filterExtensions = (extensions) => {
    return extensions.filter((extension) => {
      return Object.keys(filters).every((op) => {
        // If the filter is not active, don't filter by it
        if (!filters[op]) return true;
        // Find if the extension has the op defined and matches the filter
        const opEntry = extension.ops.find((operation) => Object.keys(operation)[0] === op);
        return opEntry ? opEntry[op] === true : false;
      });
    });
  };

  // Render function for cards with add/remove button
  const renderCards = (extensions, isUserExtension = false) => {
    return extensions.map((extension, index) => (
      <div className="ext-card" key={index}>
        <img src={extension.image} alt={extension.name} className="ext-card-image" />
        <div className="ext-card-content">
          <h3 className="ext-card-title">{extension.name}</h3>
          <p className="ext-card-description">{extension.info}</p>
          {isUserExtension ? (
            <button className="ext-card-button remove" onClick={() => removeExtension(extension)}>
              Remove
            </button>
          ) : (
            <button
              className="ext-card-button add"
              onClick={() => addExtension(extension)}
              disabled={userExtensions.some((ext) => ext.name === extension.name)}
            >
              {userExtensions.some((ext) => ext.name === extension.name) ? 'Added' : 'Add'}
            </button>
          )}
        </div>
      </div>
    ));
  };

  return (
    <div className="extensions-page">
      <div className="ext-tabs">
        <button
          className={`ext-tab-button ${activeTab === 'extensions' ? 'active' : ''}`}
          onClick={() => setActiveTab('extensions')}
        >
          Extensions
        </button>
        <button
          className={`ext-tab-button ${activeTab === 'myExtensions' ? 'active' : ''}`}
          onClick={() => setActiveTab('myExtensions')}
        >
          My Extensions
        </button>
      </div>

      {/* Filtering options */}
      <div className="filter-controls">
        {Object.keys(filters).map((op) => (
          <label key={op} className="filter-label">
            <input
              type="checkbox"
              checked={filters[op]}
              onChange={() => handleFilterChange(op)}
            />
            {op.replace(/-/g, ' ')}
          </label>
        ))}
      </div>

      <div className="ext-tab-content">
        {activeTab === 'extensions' && (
          <div className="ext-grid">{renderCards(filterExtensions(interfaceExtensions))}</div>
        )}
        {activeTab === 'myExtensions' && (
          <div className="ext-grid">{renderCards(filterExtensions(userExtensions), true)}</div>
        )}
      </div>
    </div>
  );
};

export default Extensions;